<template>
  <div class="tgh-right-nav">
    <div class="tgh-ham-menu d-inline d-sm-none" @click="toggleMenu()">
        <i class="fa fa-bars"></i>
    </div>
    <ul>
        <li>
            <router-link to="/gallery-catalogue" class="tgh-logo">
                <img src="../assets/images/tengah-logo.png" alt="">
            </router-link>
        </li>
        <!-- <li>
            <a :href="(sosmed.facebook) ? sosmed.facebook : 'https://web.facebook.com/tengahbystbd/'" target="_blank">
                <img src="../assets/images/icon-fb.png" alt="">
            </a>
        </li> -->
        <li>
            <a :href="(sosmed.instagram) ? sosmed.instagram : 'https://www.instagram.com/tengahtengah_/'" target="_blank">
                <img src="../assets/images/icon-ig.png" alt="">
            </a>
        </li>
        <li>
            <a :href="(sosmed.email) ? 'mailto:'+sosmed.email : 'mailto:info@tengahtengah.com'" target="_blank">
                <img src="../assets/images/icon-envelope.png" alt="">
            </a>
        </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'RightNav',
  props: ['sosmed'],
  methods : {
      toggleMenu() {
          this.$parent.toglMenu()
      }
  }
}
</script>
